import gql from 'graphql-tag';

const ATTRIBUTION_AUDIENCES_LAUNCHER = gql`
  query getAudiences($orgId: String, $type: String) {
    getAudiences(data: { orgId: $orgId, type: $type })
  }
`;

export default ATTRIBUTION_AUDIENCES_LAUNCHER;
